import { defineMessages } from 'react-intl';

type MessageKeys = 'createButtonDisabledTooltip';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		createButtonDisabledTooltip: {
			id: 'ai-mate.agent-create-button.create-button-disabled-tooltip',
			defaultMessage: "You don't have permission to create agents in this site",
			description:
				'Tooltip to show when the create agent button is disabled due to user not having rovo agent create permissions on the site',
		},
	});

export default message;
